<ng-template #modalContent let-c="close" let-d="dismiss">
    <form novalidate [formGroup]="form" (submit)="onSubmit($event)">
        <div class="modal-header">
            <div>
                <h4 class="modal-title d-block ">{{ 'importCustomersAsCsv' | translate }}</h4>
                <p>{{ 'importCustomersCsvExample' | translate }}</p>
            </div>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <textarea class="form-control" rows="4" [formControl]="form.get('importArea')"></textarea>
            <div [val-messages]="form.get('importArea')">
                <span val-message="required">{{ 'requiredErrorMessage' | translate }}</span>
            </div>
            <h6 class="mt-2">{{ 'chooseCustomersCategory' | translate}}</h6>
            <app-customer-categories [formControlType]="FormControlTypeEnum.Select" (customerCategoryChanged)="onCustomerCategoryChanged($event)"></app-customer-categories>
            <h6 class="mt-2">{{ 'chooseSiteCategory' | translate }}</h6>
            <app-trigger-categories (triggerCategoryChanged)="onTriggerCategoryChanged($event)"></app-trigger-categories>
        </div>
        <div class="modal-footer">
            <div style="width: 100%"><p class="error-message text-center">{{ errorMessage }}</p></div>
            <button [ladda]="isLoading" type="submit" class="btn btn-sm btn-primary">{{ 'import' | translate }}</button>
        </div>
    </form>
</ng-template>
<button type="button" class="btn btn-sm btn-primary button-with-icon"
        (click)="openImportModal(modalContent); $event.preventDefault();">
    {{ 'import' | translate }} {{ 'customers' | translate | lowercase }}
    <svg class="icon" width="14" height="14">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="./sprites/symbol/icons.svg#user-plus"
             fill="currentColor"/>
    </svg>
</button>



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/import-customers-modal/import-customers-modal.component.html